export default __webpack_public_path__ + "static/media/pause2.d8c995a8.svg";